import { BaseModel } from '@/api/base-model'
import { OrderType } from '@/api/types'

export interface OrderSettingsPipelineMapping {
    [index: string]: string
}

export class OrderSettings extends BaseModel<OrderSettings> {
    protected collectionName = 'order_settings'

    constructor(
        public id: string,
        public enabled: boolean,
        public enabledTypes: OrderType[],
        public typeMapping: object,
        public pipelineMapping: OrderSettingsPipelineMapping,
        public allowManualCreation: boolean,
    ) { super(id) }

    getMapping(key: string): string|null {
        if (this.pipelineMapping[key]) {
            return this.pipelineMapping[key]
        }

        if (this.typeMapping[key]) {
            return this.typeMapping[key]
        }

        return null
    }

    static fromData(data: any): OrderSettings {
        if (data === null || typeof data === 'string' || data instanceof OrderSettings) {
            return data
        }

        return new OrderSettings(
            data.id,
            data.enabled,
            data.enabledTypes,
            data.typeMapping && data.typeMapping.length !== 0 ? data.typeMapping : {},
            data.pipelineMapping && data.pipelineMapping.length !== 0 ? data.pipelineMapping : {},
            data.allowManualCreation,
        )
    }

    static new(id: string): OrderSettings {
        return new OrderSettings(
            id,
            false,
            [],
            {},
            {},
            false,
        )
    }
}
